import React from "react";
import "./styles.css";
import { StorageService } from "../../config/storage";
import Images from "../../constants/images";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  onHandleLogout = () => {
    StorageService.clearAll();
    window.location.reload();
    // window.location.href = '/login'
  };

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="error-page">
          <img
            src={Images.dangerSign}
            alt="Error Illustration"
            className="error-image"
          />
          <h1 className="error-heading">Server Error</h1>
          <p className="error-message">
            Sorry, something went wrong on our end. Please try again later.{" "}
            <span onClick={this.onHandleLogout} className="error-link">
              Go to Home Page
            </span>
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
